import { useSelector } from 'react-redux'
import { useFirestoreConnect, isLoaded } from 'react-redux-firebase'

import { useAuth } from 'hooks'

export const useExtCard = () => {
    const { uid } = useAuth()

    useFirestoreConnect({
        collection: 'userAchievements',
        doc: uid
    })

    const isExtensionInstalled = useSelector(state => state.extensionStatus.isInstalled)

    const userAchievements = useSelector(state => state.firestore.data?.userAchievements)

    const firstQuickGuiddeIsCreated = userAchievements?.[uid]?.createdFirstQuickGuidde
    const firstExtInstall = userAchievements?.[uid]?.firstExtInstall

    // extension was never installed
    const showWhenIsNotInstalled = !isExtensionInstalled && !firstExtInstall
    // extension installed but user never recorded QG
    const showWithQG = isExtensionInstalled && !firstQuickGuiddeIsCreated

    const showExtCard = isLoaded(userAchievements) && (showWhenIsNotInstalled || showWithQG)

    return showExtCard
}
